export enum ConversationMessageType {
    // Chat and Call types
    CHAT_MESSAGE = 'chat_message',
    CHAT_READ_INDICATOR = 'chat_read_indicator',
    CHAT_REACTION_EMOJI = 'chat_reaction_emoji',
    CALL_MISSED = 'call_missed',
    CALL_CONNECTED = 'call_connected',
    CALL_BLOCKED = 'call_blocked',
    CALL_PERMITTED = 'call_permitted',

    // Privacy and Relationship types
    RELATIONSHIP_SET_TRUSTED = 'relationship_set_trusted',
    RELATIONSHIP_SET_NEGATIVE = 'relationship_set_negative',
    SCAN_HIT = 'scan_hit',
    SCAN_MISS = 'scan_miss',
    PRIVACY_REQUEST_CREATED = 'privacy_request_created',
    PRIVACY_REQUEST_SUBMITTED = 'privacy_request_submitted',
    PRIVACY_REQUEST_CLOSED = 'privacy_request_closed',
    NOTIFY_DATA_EXPOSED_ON_COMPANY = 'notify_data_exposed_on_company',
    NOTIFY_DATA_NOT_EXPOSED_ON_COMPANY = 'notify_data_not_exposed_on_company',
    REQUEST_CLOSED_DUE_TO_NOT_HAVING_LICENSE = 'request_closed_due_to_not_having_license',
    REQUEST_CLOSED_DUE_TO_NOT_BEING_ERASURE_WORKFLOW = 'request_closed_due_to_not_being_erasure_workflow',
    RESETTING_REQUEST_TO_PENDING = 'resetting_request_to_pending',
    COMPANY_EXPOSURE_REQUEST_CONFIRMED = 'company_exposure_request_confirmed',
    COMPANY_EXPOSURE_REQUEST_REJECTED = 'company_exposure_request_rejected',
    PRIVACY_REQUEST_REOPENED = 'privacy_request_reopened',
    PRIVACY_REQUEST_ASSIGNED = 'privacy_request_assigned',
    PRIVACY_REQUEST_FAILED = 'privacy_request_failed',
    PRIVACY_REQUEST_CANCELED = 'privacy_request_canceled',
}

